module.exports = __webpack_public_path__ + "static/img/fm7.d960502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm7.jpg
// module id = DgI1
// module chunks = 1